<template>
  <div>
    <!-- <h2>ccbzSuccess</h2> -->
    <div class="ccbzSuccess">
      <img src="../../assets/img/ccbz/success.png" alt />
      <h2>缴费成功</h2>
      <div>
        <div>
          <p>订单编号：</p>
          <p>{{info.order}}</p>
        </div>
        <div>
          <p>逝者姓名：</p>
          <p>{{info.aDecName}}</p>
        </div>
        <div>
          <p>缴费年限：</p>
          <p v-if="info.year">{{info.year}}</p>
        </div>
        <div>
          <p>缴费金额：</p>
          <p v-if="info.paymentTotal">{{info.paymentTotal}}元</p>
        </div>
        <div>
          <p>缴费状态：</p>
          <p>{{info.isConfirm == 1 ? '已支付':''}}</p>
        </div>
      </div>
      <span>
        <van-button type="info" size="large" @click="toSearch" class="btn">返回</van-button>
      </span>
    </div>
  </div>
</template>


<script>
export default {
  name: "CcbzSuccess",
  data() {
    return {
      info: {
        isConfirm: "1",
        paymentTotal: "",
        year: "",
        aDecName: "",
        order: "",
        deptId: ""
      }
    }
  },
  mounted() {
    this.info = this.$route.query
    var pattern3 = new RegExp("[0-9]+")
    pattern3.test(this.info.year) ? this.info.year += '年' :this.info.year 
  },
  methods: {
    toSearch() {
      this.$router.push({
        path: `/funeralAndInterment?deptId=${this.info.deptId}&vde=${this.info.deptId}&echo='echo'`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ccbzSuccess {
  height: calc(100vh - 64px);
  background: #f9f9f9;
  padding-top: 64px;
  > img {
    width: 37px;
    display: block;
    margin: 0 auto;
  }
  h2 {
    font-size: 22px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
    margin: 20px 0 30px 0;
    text-align: center;
  }
  > div {
    background: #fff;
    width: 70%;
    border-radius: 10px;
    margin: 0 auto;
    padding: 20px;
    padding-bottom: 10px;
    height: 180px;
    display: grid;
    > div {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    p {
      font-size: 14px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
    }
    p:last-child {
      text-align: right;
    }
  }
  span {
    display: flex;
    justify-content: center;
  }
  .btn {
    background: #00549d;
    border-radius: 22px;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 700;
    width: 80%;
    position: fixed;
    display: block;
    bottom: 20px;
    margin: 0 auto;
  }
  .van-button--info {
    border: 0;
  }
}
</style>